import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export interface Role {
  id?: string;
  name: string;
}

export interface AuthUserResponse {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  name?: string;
  role: Role | string;
}

export interface AuthLoginResponse {
  access_token: string;
  user: AuthUserResponse;
}

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: createAuthBaseQuery(),
  endpoints: (builder) => ({
    login: builder.mutation<AuthLoginResponse, { email: string; password: string }>({
      query: (body) => ({ url: 'auth/login', method: 'POST', body }),
    }),
    register: builder.mutation<AuthLoginResponse, Record<string, unknown>>({
      query: (body) => ({ url: 'auth/register', method: 'POST', body }),
    }),
    forgotPassword: builder.mutation<{ message: string }, { email: string }>({
      query: (body) => ({ url: 'auth/forgot-password', method: 'POST', body }),
    }),
    resetPassword: builder.mutation<{ message: string }, { token: string; newPassword: string }>({
      query: (body) => ({ url: 'auth/reset-password', method: 'POST', body }),
    }),
    getCurrentUser: builder.query<AuthUserResponse, void>({
      query: () => 'auth/me',
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useGetCurrentUserQuery,
} = authApi;
